import React from "react";
import { ManualClientPositionForm } from "./ManualClientPositionForm";
import { ClientPosition } from "@/lib/api/risk/positions";

interface EditManualClientPositionFormProps {
    position: ClientPosition;
    onSuccess: () => void;
    onCancel?: () => void;
    showCancelButton?: boolean;
}

export function EditManualClientPositionForm({ position, onSuccess, onCancel, showCancelButton = true }: EditManualClientPositionFormProps) {
    return (
        <ManualClientPositionForm
            mode="edit"
            initialData={position}
            onSuccess={onSuccess}
            onCancel={onCancel}
            showCancelButton={showCancelButton}
        />
    );
}